export default __webpack_public_path__ + "static/media/prbicon_tutorial.ea8feb28.svg";